import React from 'react';

import { MainMenuObject } from 'features/menu/components/menu-tile-grid/menu-tile/types';

import { ICombo, IItem, IPicker } from '@rbi-ctg/menu';
import FormatMenuPrice from 'components/menu-utils/format-menu-price';

export type AnyMenuObject = ICombo | IItem | IPicker | MainMenuObject;

interface IFormattedCaloriesAndPriceRangeForMenuObject {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (menuObject: AnyMenuObject) => string,
    getPrices: (menuObject: AnyMenuObject) => React.ReactNode
  ): { calories: string; price: React.ReactNode };
}

const formattedCaloriesAndPriceRangeForMenuObject: IFormattedCaloriesAndPriceRangeForMenuObject = (
  menuObject,
  getCaloriesRange,
  getPrices
) => {
  const price = getPrices(menuObject);
  return {
    calories: getCaloriesRange(menuObject),
    price,
  };
};

interface IGetCaloriesAndPrice {
  (menuObject: IPicker | MainMenuObject, getCaloriesRange: (menuObject: AnyMenuObject) => string): {
    calories: string;
    price: React.ReactNode;
  };
}

export const getCaloriesAndPrice: IGetCaloriesAndPrice = (menuObject, getCaloriesRange) => {
  const getPrices = (comboOrItem: AnyMenuObject) => {
    return <FormatMenuPrice menuItemId={comboOrItem._id} />;
  };

  return formattedCaloriesAndPriceRangeForMenuObject(menuObject, getCaloriesRange, getPrices);
};
